import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FrontendSettingsNavComponent } from './frontend-settings-nav.component';
import { FrontendIconsModule } from '@tablesready/frontend-icons';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { IonicModule } from '@ionic/angular';

@NgModule({
  declarations: [FrontendSettingsNavComponent],
  imports: [
    CommonModule,
    FrontendIconsModule,
    NgbTooltipModule,
    RouterLink,
    RouterLinkActive,
    IonicModule,
    RouterLink,
  ],
  exports: [FrontendSettingsNavComponent],
})
export class FrontendSettingsNavModule { }
